/** True when the visitor has asked the system to reduce motion. */
export function prefersReducedMotion(): boolean {
  return (
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}

/**
 * Scroll to the top of the page, honouring `prefers-reduced-motion`.
 *
 * The `scroll-behavior: auto !important` in the global reduced-motion block is
 * not enough on its own: per CSSOM-View the computed `scroll-behavior` is only
 * consulted when the `behavior` option is `"auto"`, so passing `'smooth'`
 * explicitly overrides it and animates anyway. The preference has to be read
 * here, which is why every caller goes through this helper.
 */
export function scrollToTop(): void {
  window.scrollTo({ top: 0, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
}
